import React from 'react'
import RcSlider from '../../form/RcSlider'

class Step3 extends React.Component {
  constructor(props) {
    super(props);

    const {
      instagram_percentage,
      fb_percentage,
      youtube_percentage,
      google_network_percentage,
      google_search_percentage
    } = this.props.data ;

    if (this.props.insights) {
      this.instagramUsage = this.props.insights.answers_insight.find(answer => answer.code === 'q303new_4').value;
      this.fbUsage = this.props.insights.answers_insight.find(answer => answer.code === 'q303new_1').value;
      this.youtubeUsage = this.props.insights.answers_insight.find(answer => answer.code === 'q303new_16').value;
    }

    this.allocationErrorMessage = 'the allocation should not be less or more than 100%';

    this.state = {
      instagram_percentage: instagram_percentage || this.calculateInstagram() || 20,
      fb_percentage: fb_percentage || this.calculateFb() || 20,
      youtube_percentage: youtube_percentage || this.calculateYoutube() || 20,
      google_network_percentage: google_network_percentage ||  20,
      google_search_percentage: google_search_percentage || this.calculateGoogleSearch() || 20
    };
  }

  calculateInstagram = () => {
    const { insights } = this.props;

    if (insights) {
      return Math.round(this.instagramUsage*60/(this.fbUsage + this.youtubeUsage + this.instagramUsage))
    }
  };

  calculateYoutube = () => {
    const { insights } = this.props;
    if (insights) {
      return Math.round(this.youtubeUsage*60/(this.fbUsage + this.youtubeUsage + this.instagramUsage))
    }
  };

  calculateFb = () => {
    const { insights } = this.props;
    if (insights) {
      return Math.round(this.fbUsage*60/(this.fbUsage + this.youtubeUsage + this.instagramUsage))
    }
  };

  calculateGoogleSearch = () => {
    const { insights } = this.props;
    if (insights) {
      return 100 - (this.calculateYoutube() + this.calculateFb() + this.calculateInstagram() + 15)
    }
  };

  submit = () => {
    if (this.checkError()) {
      this.setState({ errors: this.allocationErrorMessage })
    } else {
      this.props.submit(this.state)
    }
  };

  calculateTotal = () => {
    const {
      instagram_percentage,
      fb_percentage,
      youtube_percentage,
      google_network_percentage,
      google_search_percentage
    } = this.state;

    const total = instagram_percentage + fb_percentage + youtube_percentage + google_network_percentage + google_search_percentage;

    return total;
  }

  checkError = () => {
    if (this.calculateTotal() !== 100) return true
    return false
  };

  setError = () => {
    if (this.checkError()) {
      this.setState({ errors: this.allocationErrorMessage })
    } else {
      this.setState({ errors: '' })
    }
  };

  render() {
    const {
      instagram_percentage,
      fb_percentage,
      youtube_percentage,
      google_network_percentage,
      google_search_percentage,
      errors
    } = this.state;

    return (
      <React.Fragment>
        <p className="title mb-10">Specify channel allocation</p>

        <p className="mb-30 text-tuna">Lussy will crawl your website to find relevant information like social profiles.</p>

        <div className="mx-auto" style={{ maxWidth: '370px' }}>
          <div className="bg-wisp-pink left-align mb-30 p-20 rounded-6">
            <p>Fine tuned based on your persona!</p>

            <p className="fs-13 sfpro-regular text-tuna">Based on your persona and the goal you specified we have fine tuned the allocation to maximise efficiency.</p>
          </div>

          <div className="rc-slider--facebook left-align mb-35">
            <RcSlider
              value={fb_percentage}
              onChange={(fb_percentage) =>
                this.setState({fb_percentage}, this.setError)}
              label="Facebook"
              max={100}
              min={0}
              unit="%"
            />
          </div>

          <div className="rc-slider--instagram left-align mb-35">
            <RcSlider
              value={instagram_percentage}
              onChange={(instagram_percentage) =>
                this.setState({instagram_percentage}, this.setError)}
              label="Instagram"
              max={100}
              min={0}
              unit="%"
            />
          </div>

          <div className="rc-slider--youtube left-align mb-35">
            <RcSlider
              value={youtube_percentage}
              onChange={(youtube_percentage) =>
                this.setState({youtube_percentage}, this.setError)}
              label="Youtube"
              max={100}
              min={0}
              unit="%"
            />
          </div>

          <div className="rc-slider--google left-align mb-35">
            <RcSlider
              value={google_network_percentage}
              onChange={(google_network_percentage) =>
                this.setState({google_network_percentage}, this.setError)}
              label="Google Network"
              max={100}
              min={0}
              unit="%"
            />
          </div>

          <div className="rc-slider--google left-align mb-35">
            <RcSlider
              value={google_search_percentage}
              onChange={(google_search_percentage) =>
                this.setState({google_search_percentage}, this.setError)}
              label="Google Search"
              max={100}
              min={0}
              unit="%"
            />
          </div>

          <a
            className={`${errors && 'disabled'} btn btn--primary col-12 mb-10`}
            onClick={this.submit}
          >
            {errors && `Total: ${this.calculateTotal()} %` || 'Next'}
          </a>
        </div>
      </React.Fragment>
    );
  }
}

export default Step3
